import React, { useEffect, useState } from "react";
import { Box, Button, Typography, IconButton, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DescriptionIcon from "@mui/icons-material/Description";
import AdminModuleAPIs from "../../../utilities/api/tutorials/AdminModuleAPIs";

const TutorialDetailView = ({ onBack }) => {
  const selected = useSelector(
    (state) => state.tutorialEdit.tutCurrentItem
  );

  const [moduleData, setModuleData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selected?.id) return;

    const loadModule = async () => {
      try {
        setLoading(true);
        const data = await AdminModuleAPIs.ModuleDetailGet(
          selected.id
        );
        console.log("MODULE DETAIL RESPONSE:", data);
        setModuleData(data);
      } catch (error) {
        console.error("Error loading module:", error);
      } finally {
        setLoading(false);
      }
    };

    loadModule();
  }, [selected]);

  const handleBack = () => {
    if (onBack) onBack();
  };

  if (!selected) {
    return <Typography>No tutorial selected</Typography>;
  }

  if (loading) {
    return <Typography>Loading tutorial...</Typography>;
  }

  if (!moduleData) {
    return <Typography>Unable to load tutorial</Typography>;
  }

const rawVideos = moduleData?.videos || [];


  return (
    <Box
      sx={{
        p: 3,
        width: "100%",
        boxSizing: "border-box",
        overflow: "auto",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 4,
        }}
      >
        <IconButton onClick={handleBack}>
          <ArrowBackIcon fontSize="large" />
        </IconButton>

        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {moduleData.name}
        </Typography>
      </Box>

      {/* ACTION BUTTONS */}
      <Box sx={{ display: 'flex', justifyContent: "flex-end", }} >
        {/* <Button
          variant="contained"
          startIcon={<PlayArrowIcon />}
        >
          Watch Now
        </Button> */}

        {/* Document button only if document exists */}
        {moduleData.document && (
          <Button
  variant="outlined"
  startIcon={<DescriptionIcon />}
  disabled={!moduleData?.document}
 onClick={() => window.open(moduleData.document, "_blank")}
  sx={{
    color: '#1976d2',
    borderColor: '#1976d2',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    borderRadius: 1,
    px: 3,
    py: 1,
    '&:hover': {
      borderColor: '#1565c0',
      color: '#1565c0',
      backgroundColor: '#f5f9ff'
    }
  }}
>
  Document
</Button>

        )}
      </Box>

      {/* ABOUT SECTION */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 2 }}
        >
          About Course
        </Typography>

        <Typography sx={{ color: "#666" }}>
          {moduleData.description ||
            "No description available"}
        </Typography>
      </Box>

      {/* VIDEO SECTION */}
      {rawVideos.length > 0 && (
        <Box>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, mb: 3 }}
          >
            Video Course ({rawVideos.length} videos)
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
          {rawVideos.map((item, index) => {
  const video = item.video; 

  return (
    <Paper
      key={video.id || index}
      onClick={() =>
        window.open(
          video.link,
          "_blank",
          "noopener,noreferrer"
        )
      }
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 2,
        cursor: "pointer",
        transition: "0.3s",
        "&:hover": {
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        },
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid #1976d2",
          borderRadius: "8px",
        }}
      >
        <PlayArrowIcon sx={{ color: "#1976d2" }} />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontWeight: 500 }}>
          {video.title}
        </Typography>
      </Box>

      <Typography sx={{ color: "#666" }}>
        {video.video_length || "--:--"}
      </Typography>
    </Paper>
  );
})}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default TutorialDetailView;
